import { ConsentObject, ConsentPurpose, ConsentStatus } from "./ConsentTypes";

export const STORAGE_KEY = "agencyq_consent_v1";
export const CONSENT_PROVIDER_NAME = "AgencyQ Consent";

// Helper to build the Consent Array for Salesforce
export const buildSalesforceConsents = (
    marketingRx: boolean,
    analyticsRx: boolean
): ConsentObject[] => {
    // "Tracking" is the only purpose the Salesforce Interactions SDK
    // recognizes, and it's the master switch for the beacon. If either
    // Marketing OR Analytics is granted, we opt in to Tracking; only deny it
    // when the visitor has denied both.
    const masterTracking = marketingRx || analyticsRx;

    return [
        {
            provider: CONSENT_PROVIDER_NAME,
            purpose: ConsentPurpose.Tracking,
            status: masterTracking ? ConsentStatus.OptIn : ConsentStatus.OptOut,
        },
    ];
};
